import React, { type ReactNode } from "react";
import { Flex, SimpleGrid, type SpaceProps } from "@chakra-ui/react";
import { TextTitle } from "ui/text";
import { FillImage } from "components/images";
import { type BlogSimple } from "lib/sanity";
import { Card } from "ui/cards";

export function GridHeading({ title, action }: { title: string; action: ReactNode }) {
  return (
    <Flex
      flexDir={{ base: "column", lg: "row" }}
      gap="small"
      justify={{ base: "start", lg: "space-between" }}
      align={{ base: "start", lg: "end" }}
      mb={{ base: "bigger", lg: "biggest" }}
    >
      <TextTitle size="lg" title={title} />
      {action}
    </Flex>
  );
}

export function SectionGrid({ children, ...props }: { children: ReactNode } & SpaceProps) {
  return (
    <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} columnGap="small" {...props}>
      {children}
    </SimpleGrid>
  );
}

export function BlogCard({ blog }: { blog: BlogSimple }) {
  return (
    <Card
      mt="0"
      mb="big"
      mx="auto"
      variant="shadow"
      href={`/blog/${blog.slug}`}
      title={blog.title}
      description={blog.excerpt}
      mediaRatio={2 / 1}
      media={<FillImage src={`${blog.imageUrl}?w=1000`} alt={blog.imageAlt ?? blog.title} placeholder="empty" />}
    />
  );
}
